import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import { Section as BaseSection, Container } from '../../components';
import { media } from '../../styles/helpers';
import { fontSizes, offsets, colors, transitions } from '../../styles';
import { switchCategory } from '../../store/reducers/menu';
import { menuItems as data } from '../../data';

const menuItems = Object.entries(data).reduce(
  (accumulator, [key, { name }]) => {
    accumulator[key] = name;
    return accumulator;
  },
  {}
);

const Categories = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${offsets.lg} -${offsets.sm};
  font-size: ${fontSizes.md};
  font-weight: bold;

  ${media.sm`
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
  `}
`;

const withItemActiveStyles = ({ isActive }) => {
  if (isActive) {
    return css`
      color: ${colors.primary};
      cursor: default;

      &::before {
        transform-origin: 100% 50% !important;
      }
    `;
  }

  return css`
    cursor: pointer;

    &:hover {
      color: ${colors.primary};

      &:before {
        transform: scaleX(1);
      }
    }
  `;
};

const NavItem = styled.div`
  position: relative;
  padding: ${offsets.sm};
  transition: color ${transitions.base};
  ${withItemActiveStyles};

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    right: ${offsets.xs};
    left: ${offsets.xs};
    height: 4px;
    background: ${colors.primary};
    transform: scaleX(0);
    transform-origin: 0% 50%;
    transition: transform ${transitions.base};
  }
`;

const Head = ({ switchCategory, activeCategory }) => (
  <Categories>
    {Object.entries(menuItems).map(([key, name]) => (
      <NavItem
        key={`order-menu-item-${key}`}
        onClick={() => switchCategory(key)}
        isActive={activeCategory === key}
      >
        {name}
      </NavItem>
    ))}
  </Categories>
);

Head.propTypes = {
  switchCategory: PropTypes.func.isRequired,
};

const mapStateToProps = ({ menu }) => ({
  activeCategory: menu.activeCategory,
});

export default connect(
  mapStateToProps,
  { switchCategory }
)(Head);
